export default __webpack_public_path__ + "static/renesas-qcstudio-min-aee438f3e3510da13b88e4f634777f21.png";